<template lang="pug"></template>

<script>
export default {
    name: 'BotaoGestaoOperacoes',
    componentOptions: {
        title: 'Operação',
        actions: [
            [
                {
                    name: 'Operação',
                    iconClass: 'lyra-icon lyra-gestao',
                    showView: false,
                    action: 'abrirOperacoes',
                    route: 'operacao'
                }
            ]
        ]
    },

    methods: {
        abrirOperacoes() {
            if (this.$route.name !== 'operacao') {
                this.$router.push({ name: 'operacao' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
